import { notification } from 'antd';

let lastErrorTime = 0;
const ERROR_THROTTLE_MS = 1000;

export function showErrorNotification(message: string, description: string) {
  const now = Date.now();
  if (now - lastErrorTime < ERROR_THROTTLE_MS) {
    return;
  }
  lastErrorTime = now;

  notification.error({ message, description });
}
